import type { PreviewDialogType } from "../../types";
import { localEditorPreviewDialogTypeVar } from "../../State";

export const setPreviewDialogType = (previewDialogType: PreviewDialogType) => localEditorPreviewDialogTypeVar(previewDialogType);
